import * as React from 'react';

export const LinkedInIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1667 1.5H3.83333C2.54417 1.5 1.5 2.54417 1.5 3.83333V20.1667C1.5 21.4558 2.54417 22.5 3.83333 22.5H20.1667C21.4558 22.5 22.5 21.4558 22.5 20.1667V3.83333C22.5 2.54417 21.4558 1.5 20.1667 1.5ZM7.84958 19.5833H4.71708V9.47125H7.84958V19.5833ZM6.26875 8.14708C5.245 8.14708 4.41667 7.31292 4.41667 6.28042C4.41667 5.24792 5.245 4.41375 6.26875 4.41375C7.2925 4.41375 8.12083 5.24792 8.12083 6.28042C8.12083 7.31292 7.2925 8.14708 6.26875 8.14708ZM19.5833 19.5833H16.4683V14.275C16.4683 12.8196 15.9142 12.0058 14.765 12.0058C13.5108 12.0058 12.8575 12.8517 12.8575 14.275V19.5833H9.85333V9.47125H12.8575V10.8333C12.8575 10.8333 13.7617 9.16208 15.9054 9.16208C18.0492 9.16208 19.5862 10.4717 19.5862 13.1812V19.5833H19.5833Z"
        fill="#0A66C2"
      />
    </svg>
  );
};
